import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Explanation from "../../../layout/admin/Explanation";

import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import Select from "../../../ui/Select";
import StudentModal from "./StudentModal";
import {
  validateRequired,
  validateMaxlength,
} from "../../../../utils/validate";
import { getCourse } from "../../../../services/apiCourseApplicant";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import { postAddCourseApplicant } from "../../../../services/apiCourseApplicant";
import Completion from "./Completion";
import TextAreaField from "../../../ui/TextAreaField";
import { useAuth } from "../../../../contexts/AuthContext";
import { AUTH_UNIVERSITY } from "../../../../utils/config";

const AddCourseApplicant = () => {
  // ユーザー情報
  const { user } = useAuth();
  // 講座ID(サイトID + 講座ID 8桁)
  const { id } = useParams();
  // 確認
  const [isConfirmation, setIsConfirmation] = useState(false);
  // 申込方法
  const [howApply, setHowApply] = useState([]);
  // 学生選択モーダル表示ステータス
  const [showStudentModalFlag, setShowStudentModalFlag] = useState(false);
  // 学生情報
  const [studentInfo, setStudentInfo] = useState({});
  // 学生情報表示ステータス
  const [studentDisplay, setStudentDisplay] = useState(false);
  // 完了フラグ
  const [isCompFlg, setIsCompFlg] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  // 初回レンダリング
  useEffect(() => {
    // 権限確認
    if (user.authority == AUTH_UNIVERSITY) {
      navigate("/admin/404");
    }
    (async function () {
      // 講座詳細データ取得
      const data = await getCourse({ id });
      if (data == undefined || !data) return;
      if (Object.keys(data).length === 0) {
        navigate("/admin/404");
      }
      // 講座詳細データセット
      setValue("course_name", data["course_name"]);
      setValue("university_id", data["univ_id"]);
      setValue("cancel", data["cancel"]);
    })();

    (async function () {
      // 区分データ取得
      const data = await getCodeMasterList({ code: "CD005" });
      if (data == undefined || !data) return;
      // 区分データを選択肢としてセット
      setHowApply(
        data.map((d) => {
          return { text: d.d_text, value: d.d_value };
        })
      );
    })();
  }, []);

  // 学生情報
  useEffect(() => {
    if (studentDisplay) {
      // 選択した学生の情報をセット
      setValue("login_id", studentInfo["login_id"]);
      setValue("name", studentInfo["name"]);
      setValue("user_id", studentInfo["user_id"]);
    } else {
      // 学生の情報表示を削除
      setValue("login_id", "");
      setValue("name", "");
      setValue("user_id", "");
    }
  }, [studentInfo]);

  // 学生選択モーダル表示
  const showStudentModal = () => {
    setShowStudentModalFlag(true);
  };

  // 学生情報削除
  const deleteStudentInfo = () => {
    setStudentDisplay(false);
    setStudentInfo({});
  };

  // 講座詳細へ戻る
  const handleBack = (e) => {
    navigate("/admin/course/detail/" + id + "/2");
  };

  // 登録画面へ戻る
  const handleBackConfirmation = () => {
    setIsConfirmation(false);
    scrollTop();
  };

  // 確認 or 登録
  async function onSubmit(data) {
    if (!isConfirmation) {
      setIsConfirmation(true);
      scrollTop();
    }
    if (isConfirmation) {
      // 新規講座申込
      const json = await postAddCourseApplicant(id, data);
      if (json) {
        // 完了画面表示
        setIsCompFlg(true);
        scrollTop();
      }
    }
  }
  return (
    <>
      {isCompFlg ? (
        <Completion
          subtitle="講座申込完了"
          explanation="講座の申込が完了いたしました。"
          link={"/admin/course/detail/" + id + "/" + 2}
          btntext="講座詳細へ戻る"
        ></Completion>
      ) : (
        <div className={styles.main}>
          <ScreenTitle>講座管理</ScreenTitle>
          <SubScreenTitle>新規講座申込</SubScreenTitle>
          <Explanation>
            必要事項をご入力の上、確認ボタンを押してください。
          </Explanation>
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <table className={styles.input_form_table}>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{}}
                  label="講座名"
                  name="course_name"
                  isStatic={true}
                />
              </tr>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{}}
                  label="大学ID"
                  name="university_id"
                  isStatic={true}
                />
              </tr>
              <tr>
                <div className={styles.row_in_button}>
                  <TextField
                    errors={errors}
                    register={register}
                    validation={{
                      ...validateRequired("いずれかの学生を選択してください"),
                    }}
                    label="学生番号(8桁)"
                    name="login_id"
                    readOnly={true}
                    isStatic={isConfirmation}
                    required={true}
                  />
                  {!isConfirmation ? (
                    <div className={styles.row_in_button__buttonbox}>
                      <Button
                        type="button"
                        styleType="search"
                        onClick={() => showStudentModal()}
                      >
                        学生選択
                      </Button>
                      <Button
                        type="button"
                        styleType="back"
                        onClick={() => deleteStudentInfo()}
                      >
                        削除
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </tr>
              <tr>
                {studentDisplay ? (
                  <div>
                    <TextField
                      errors={errors}
                      register={register}
                      validation={{}}
                      label="氏名"
                      name="name"
                      isStatic={true}
                    />
                    <div hidden>
                      <TextField
                        errors={errors}
                        register={register}
                        validation={{}}
                        label="ユーザーid"
                        name="user_id"
                        isStatic={true}
                      />
                      <TextField
                        errors={errors}
                        register={register}
                        validation={{}}
                        label="キャンセル可否"
                        name="cancel"
                        isStatic={true}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </tr>
              <tr>
                <Select
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  label="申込方法"
                  name="how_apply"
                  errors={errors}
                  options={howApply}
                  watch={watch}
                  isStatic={isConfirmation}
                  isSetdefalut={true}
                  defalut={{ text: "---選択していません---", value: 0 }}
                />
              </tr>
              <tr>
                <TextAreaField
                  errors={errors}
                  register={register}
                  validation={{
                    ...validateMaxlength(500),
                  }}
                  label="備考"
                  name="remarks"
                  isStatic={isConfirmation}
                />
              </tr>
            </table>

            <div className={styles.buttonbox}>
              {isConfirmation ? (
                <Button
                  type="button"
                  onClick={() => handleBackConfirmation()}
                  styleType="back"
                >
                  変更ページへ戻る
                </Button>
              ) : (
                <Button
                  type="button"
                  onClick={() => handleBack()}
                  styleType="back"
                >
                  講座詳細へ戻る
                </Button>
              )}
              <Button type="submit" styleType="register">
                {isConfirmation ? "登録" : "確認"}
              </Button>
            </div>
          </Form>
          {!isConfirmation ? (
            <div className={styles.buttonbox}>
              <Link className={styles.link} to="/admin/top">
                トップページへ戻る
              </Link>
            </div>
          ) : (
            <></>
          )}
          <StudentModal
            course_id={id}
            showFlag={showStudentModalFlag}
            setShowModal={setShowStudentModalFlag}
            setStudentDisplay={setStudentDisplay}
            setStudentInfo={setStudentInfo}
            key={showStudentModalFlag}
          />
        </div>
      )}
    </>
  );
};

export default AddCourseApplicant;
